import { useTranslation } from 'react-i18next';

import {
  useOrganizationDevicesSearchText,
  useUpdateOrganizationDevicesSearchText,
} from '../../../../../../features/organization';
import { Input } from '../../../../../common';
import { IOrganizationDevicesHeaderProps } from './types';

export const OrganizationDevicesHeader = ({ expanded }: IOrganizationDevicesHeaderProps) => {
  const { t } = useTranslation();
  const updateSearchText = useUpdateOrganizationDevicesSearchText();
  const value = useOrganizationDevicesSearchText();
  const onTextChange = (text: string) => updateSearchText(text);

  return (
    <div className="flex">
      <h3 className="typography-heading-large">{t('organization.title.devices')}</h3>
      {expanded && (
        <div className="flex gap-4 ml-auto items-center">
          <Input
            type="search"
            value={value}
            onChange={onTextChange}
            className="min-w-[320px]"
            placeholder={t('organization.devices.field.search.placeholder')}
          />
        </div>
      )}
    </div>
  );
};
